import Hero from './components/Hero';
import Navigation from './components/Navigation';
import ProjectCard from './components/ProjectCard';
import ContactSection from './components/ContactSection';
import ResumeSection from './components/ResumeSection';
import SectionHeader from './components/SectionHeader';
import SkillCard from './components/SkillCard';
import { contactLinks, education, experience, projects, resume, skillGroups } from './data/portfolioData';
import './App.css';

function App() {
  return (
    <main className="portfolio-shell">
      <Navigation />
      <Hero />

      <section className="section" id="skills">
        <SectionHeader eyebrow="Skills & Tools" />
        <div className="skills-grid">
          {skillGroups.map((group) => (
            <SkillCard group={group} key={group.type} />
          ))}
        </div>
      </section>

      <section className="section" id="experience">
        <SectionHeader eyebrow="Experience" title="Building useful systems with real-world impact." />
        <div className="timeline-grid">
          {experience.map((item) => (
            <article className="experience-card" key={`${item.company}-${item.role}`}>
              <p className="item-meta">{item.dates}</p>
              <h3>{item.role}</h3>
              <p className="item-company">{item.company}</p>
              <p>{item.details}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section" id="projects">
        <SectionHeader eyebrow="Projects" title="Things I am building and/or refining." />
        <div className="project-grid">
          {projects.map((project) => (
            <ProjectCard project={project} key={project.name} />
          ))}
        </div>
      </section>

      <section className="section" id="education">
        <SectionHeader eyebrow="Education" title="Two software engineering degrees from RIT." />
        <div className="education-grid">
          {education.map((item) => (
            <article className="education-card" key={item.degree}>
              <p className="item-meta">{item.dates}</p>
              <h3>{item.degree}</h3>
              <p>{item.school}</p>
            </article>
          ))}
        </div>
      </section>

      <ResumeSection resume={resume} />
      <ContactSection contactLinks={contactLinks} />
    </main>
  );
}

export default App;
